import { render, staticRenderFns } from "./InfoItemEstoque.vue?vue&type=template&id=b6da2e14&"
import script from "./InfoItemEstoque.vue?vue&type=script&lang=js&"
export * from "./InfoItemEstoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports